import { RefreshCw, Rocket } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Alert, AlertDescription } from '@/components/ui/alert'

/**
 * PUESTA EN PRODUCCIÓN. Cobrar y arrancar son dos decisiones distintas: el pago entra cuando
 * el cliente paga, pero la empresa deja de ser de prueba cuando la implementación está lista.
 */
export default function TarjetaProduccion({ c, onIrAPaso }) {
  const { chequeo } = c
  const deDatos = (code) => String(code).startsWith('EMISOR_') || ['SIN_GIRO', 'PAIS_REQUERIDO'].includes(code)
  // El catálogo del contador vive en este mismo paso, más arriba.
  const delCatalogo = (code) => String(code).startsWith('CATALOGO_')
  const irAlCatalogo = () => document.getElementById('catalogo-contador')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  return (
    <Card id="produccion" className="scroll-mt-24">
      <CardHeader><CardTitle className="text-h3">Puesta en producción</CardTitle></CardHeader>
      <CardContent className="space-y-3">
        <p className="text-body-sm text-neutral-600 dark:text-neutral-400">
          {c.tieneDemo
            ? 'La cotización ya está pagada. Cuando la migración y la configuración estén listas, esta empresa de prueba pasa a ser la real. El dueño también puede hacerlo desde su enlace.'
            : 'La cotización ya está pagada y no tuvo demo. Al pasarla a producción se crea su espacio en la nube con los datos del emisor y, si el cliente trae el suyo, con el catálogo de cuentas de su contador. Si ese catálogo no entra entero, la empresa no se activa.'}
        </p>

        {chequeo?.bloqueos?.map((b) => (
          <Alert key={b.code} variant="destructive">
            <AlertDescription>
              {b.mensaje}
              {delCatalogo(b.code) && (
                <>
                  {' '}
                  <button type="button" className="font-medium underline" onClick={irAlCatalogo}>
                    Ir al catálogo de cuentas
                  </button>
                </>
              )}
              {deDatos(b.code) && onIrAPaso && (
                <>
                  {' '}
                  <button type="button" className="font-medium underline" onClick={() => onIrAPaso(1)}>
                    Completar en el paso 1
                  </button>
                </>
              )}
            </AlertDescription>
          </Alert>
        ))}
        {chequeo?.advertencias?.map((a) => (
          <Alert key={a.code} variant="warning">
            <AlertDescription>{a.mensaje}</AlertDescription>
          </Alert>
        ))}

        <div className="flex flex-wrap gap-2">
          <Button variant="outline" onClick={() => c.revisarProduccion()}>
            <RefreshCw size={16} className="mr-1.5" /> Revisar requisitos
          </Button>
          <Button disabled={!chequeo || !chequeo.listo} onClick={c.pasarAProduccion}>
            <Rocket size={16} className="mr-1.5" /> Pasar a producción
          </Button>
        </div>
        {chequeo && !chequeo.listo && (
          <p className="text-caption text-neutral-500 dark:text-neutral-400">
            Resuelve los puntos en rojo para habilitar el botón.
          </p>
        )}
      </CardContent>
    </Card>
  )
}
